import React from "react";
import { classnames, ClickClose, PlainButton } from "@culturehq/components";

import { useDoor } from "app/hooks";

type Option = {
  label: string;
  value: any;
};

type DropdownOptionProps<T extends Option> = {
  current: T;
  onClick: (_option: T) => void;
  option: T;
};

const DropdownOption = <T extends Option>({ current, onClick, option }: DropdownOptionProps<T>) => (
  <li className={option.value === current.value ? "active" : "inactive"}>
    <PlainButton onClick={() => onClick(option)}>{option.label}</PlainButton>
  </li>
);

type DropdownProps<T extends Option> = {
  current: T;
  onChange: (_option: T) => void;
  options: T[];
};

const Dropdown = <T extends Option>({ current, onChange, options }: DropdownProps<T>) => {
  const { open, onClose, onToggle } = useDoor(false);

  const onClick = (option: T) => {
    onChange(option);
    onClose();
  };

  return (
    <ClickClose className="Dropdown" onClose={onClose}>
      <div className="dropdown">
        <button className="btn btn-default dropdown-toggle" type="button" onClick={onToggle}>
          {current.label}
          <span className="caret" />
        </button>
        <ul className={classnames("dropdown-menu", open ? "active" : "inactive")}>
          {options.map(option => (
            <DropdownOption<T>
              key={option.label}
              current={current}
              onClick={onClick}
              option={option}
            />
          ))}
        </ul>
      </div>
    </ClickClose>
  );
};

export default Dropdown;
